import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order } from 'src/app/interfaces';
import { dataStore, db } from 'src/app/app.component';
import { doc, DocumentSnapshot, onSnapshot } from 'firebase/firestore';
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardContent,
  MatCardFooter,
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-pay-landing',
  templateUrl: './pay-landing.component.html',
  styleUrls: ['./pay-landing.component.scss'],
  imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardFooter, MatButton],
})
export class PayLandingComponent implements OnInit {
  order = signal<Order | null>(null);
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('orderId')) {
      onSnapshot(
        doc(
          db,
          `organisations/${
            dataStore.selectedOrganisation.id
          }/orders/${this.route.snapshot.paramMap.get('orderId')}`,
        ),
        (docSnap: DocumentSnapshot) => {
          if (docSnap.exists()) {
            this.order.set(docSnap.data() as Order);
          }
        },
      );
    }
  }

  navigate(page: string) {
    window.location.href = `${window.location.origin}/${page}`;
  }
}
